const MOBILE_BREAKPOINT = 768;
const KEYBOARD_ANIMATION_MS = 350;

export const isMobileViewport = () => window.innerWidth < MOBILE_BREAKPOINT;

export function scrollInputIntoView(eventOrElement, options = {}) {
  if (!isMobileViewport()) return;

  const target = eventOrElement?.target ?? eventOrElement;
  if (!target || typeof target.scrollIntoView !== "function") return;

  const scroll = () => {
    target.scrollIntoView({
      block: options.block ?? "nearest",
      behavior: options.behavior ?? "auto",
    });
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(scroll);
  });

  window.setTimeout(scroll, KEYBOARD_ANIMATION_MS);
}
